import { ReactNode } from "react";

// 도구 머리 — 제목·한 줄 설명·오른쪽 버튼. 인쇄에서는 빠진다.
const ToolIntro = ({ title, description, actions }: { title: string; description: ReactNode; actions?: ReactNode }) => (
  <div className="print-hide mb-4 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
    <div className="min-w-0">
      <h1 className="text-xl font-bold">{title}</h1>
      <p className="mt-1 text-sm text-muted-foreground">{description}</p>
    </div>
    {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
  </div>
);

export default ToolIntro;
